import { ROLE_CONFIGURATION_ACTION, useRolesModalsContext } from 'modules/roles/contexts';
import { CreateRoleModal } from './CreateRoleModal';
import { UnsavedChangesModal } from '../details/UnsavedChangesModal';

interface RolesModalsProps {
  setCreated?: any;
  onDiscard?: () => void;
  onSave?: () => void;
}

export const RolesModals = ({ setCreated, onDiscard, onSave }: RolesModalsProps) => {
  const { modalState, hideModal } = useRolesModalsContext();

  if (modalState === null) return null;

  const { action } = modalState;

  switch (action) {
    case ROLE_CONFIGURATION_ACTION.CREATE_ROLE:
      return <CreateRoleModal onClose={hideModal} onCreateSuccess={setCreated} />;

    case ROLE_CONFIGURATION_ACTION.UNSAVED_CHANGES:
      return <UnsavedChangesModal onClose={hideModal} onDiscard={onDiscard} onSave={onSave} />;

    default:
      return null;
  }
};
